/* istanbul ignore file */
import React, { lazy } from 'react'

import SiteRoute from '../../components/SiteRoute'

const ThailandNLIHP = lazy(() => import('./pages/ThailandNLIHP'))

export default [<SiteRoute key="nlihp" exact path="/" component={ThailandNLIHP} />]
